/* cadian-accordion.js — shared vanilla accordion for Cadian sections.
   Markup contract:
     <div class="cad-acc" data-cad-accordion [data-single]>
       <div class="cad-acc__item">
         <button class="cad-acc__q" aria-expanded="true|false">...<span class="cad-acc__pm">+</span></button>
         <div class="cad-acc__a"><p>...</p></div>
       </div>
     </div>
   Independent toggles by default; add data-single to enforce one-open-at-a-time.
   Matches the design HTML's accordion behaviour (max-height transition). */
(function () {
  function initItem(root, item) {
    if (item.dataset.accReady) return;
    var btn = item.querySelector('.cad-acc__q');
    var ans = item.querySelector('.cad-acc__a');
    if (!btn || !ans) return;
    item.dataset.accReady = '1';

    function setOpen(open) {
      btn.setAttribute('aria-expanded', String(open));
      ans.style.maxHeight = open ? ans.scrollHeight + 'px' : null;
    }
    if (btn.getAttribute('aria-expanded') === 'true') setOpen(true);

    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      if (root.hasAttribute('data-single') && !open) {
        root.querySelectorAll('.cad-acc__item').forEach(function (o) {
          var ob = o.querySelector('.cad-acc__q');
          var oa = o.querySelector('.cad-acc__a');
          if (ob && oa) { ob.setAttribute('aria-expanded', 'false'); oa.style.maxHeight = null; }
        });
      }
      setOpen(!open);
    });
  }

  function initRoot(root) {
    root.querySelectorAll('.cad-acc__item').forEach(function (item) { initItem(root, item); });
  }

  function boot() {
    document.querySelectorAll('[data-cad-accordion]').forEach(initRoot);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // recompute open panel heights on resize
  window.addEventListener('resize', function () {
    document.querySelectorAll('.cad-acc__item').forEach(function (item) {
      var btn = item.querySelector('.cad-acc__q');
      var ans = item.querySelector('.cad-acc__a');
      if (btn && ans && btn.getAttribute('aria-expanded') === 'true') ans.style.maxHeight = ans.scrollHeight + 'px';
    });
  });

  // theme editor: init sections added/re-rendered in design mode
  document.addEventListener('shopify:section:load', function (e) {
    (e.target.querySelectorAll ? e.target : document).querySelectorAll('[data-cad-accordion]').forEach(initRoot);
  });
})();
